import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Subject } from 'rxjs';
import { debounceTime, takeUntil } from 'rxjs/operators';

@Component({
    selector: 'autocomplete',
    templateUrl: './autocomplete.component.html',
    styleUrl: './autocomplete.component.css',
    standalone: false
})
export class AutocompleteComponent implements OnInit, OnDestroy {
  @Input() searchValue: any;
  @Input() placeHolder: any;
  @Input() id: string;
  @Input() disabled: boolean;
  @Output() filterSearch = new EventEmitter();
  @Output() clickAway = new EventEmitter();
  searchControl: FormControl = new FormControl();
  public componentDestroyed$ = new Subject<void>();
  private subject: Subject<string> = new Subject();

  constructor() {}

  ngOnInit(){
    this.subject.pipe(
      debounceTime(500),
      takeUntil(this.componentDestroyed$)
    ).subscribe(searchTextValue => {
      this.filterSearch.emit(searchTextValue);
    });
  }

  sendSearchValue(searchTextValue: string){
    this.subject.next(searchTextValue);
  }

  onClickAway(){
    this.clickAway.emit();
  }

  ngOnDestroy(): void {
    this.componentDestroyed$.next();
    this.componentDestroyed$.complete();
  }
}
